import { Shelf } from "./Shelf";

export class Caddy extends Shelf {
    constructor(...props) {
        super(...props);

        this.data.caddyLaddersPitch = this.data.config.caddyLaddersPitch = Number.parseFloat(this.data.config.caddyLaddersPitch);
    }

    // while I would love to do that in the constructor,
    // we can't because the ref to the DOM element is introduced _after_ `init` was called
    async _init(data) {
        await super._init(data);

        this.eltD3.attr("class", "caddy");

        drawCaddyPitch(this);
    }

    // TODO: caddy seems to collides with internal shelves
    // canSnap(...foo) {
    //     const res = super.canSnap(...foo);
    //     return true;
    // }
}

function drawCaddyPitch(/** @type {Caddy} */ caddy) {
    const pitch = caddy.data.caddyLaddersPitch;
    const padding = caddy.data.padding;
    // The distance by which we offset the drawing of a pitch node from the border.
    // This number doesn't really matter nor does it need to be configurable.
    const offset = 10;
    if (pitch > 0) {
        const x1 = padding.left + offset;
        const x2 = caddy.data.width - padding.right - offset;
        for (var i = caddy.data.height - padding.bottom; i > padding.top; i -= pitch) {
            caddy.eltD3
                .append("circle")
                .attr("cx", x1)
                .attr("cy", i)
                .attr("r", 2)
                .attr("fill", "black");
            caddy.eltD3
                .append("circle")
                .attr("cx", x2)
                .attr("cy", i)
                .attr("r", 2)
                .attr("fill", "black");
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/plano/components/Caddy.js